function formLabelTypeCheck(isRequired, props, propName, componentName = 'Anonymous component') {
    const prop = props[propName];

    if (!prop && isRequired) {
        return new Error(propName + ' in ' + componentName + " is required");
    } else if (!prop) {
        return null;
    }

    if (!Array.isArray(prop)) {
        return new Error('Type of ' + propName + ' in ' + componentName + ' must be "array"');
    }

    if (prop.length !== 2) {
        return new Error(propName + ' in ' + componentName + ' must have a length of 2');
    }

    if (typeof prop[0] !== 'string') {
        return new Error('The first array item of ' + propName + ' in ' + componentName + ' must be either a string, "' + typeof prop[0] + '" given');
    }

    if (typeof prop[1] !== 'string') {
        return new Error('The second array item of ' + propName + ' in ' + componentName + ' must be either a string, "' + typeof prop[1] + '" given');
    }

    return null;
}

const TFormLabel = formLabelTypeCheck.bind(null, false);
TFormLabel.isRequired = formLabelTypeCheck.bind(null, true);

export { TFormLabel };